module.exports = __webpack_public_path__ + "img/plane.1044a690.jpg";